import Icon from '@xo-union/tk-component-icons';
import { FullBleedContainer, TopLevelContainer, Row, Column } from '@xo-union/tk-component-grid';
import { Body1, Hero } from '@xo-union/tk-ui-typography';
import { useMobileMedia } from '@xo-union/tk-ui-breakpoints';
import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import ViewTrackerCard from './guidanceCards/viewTracker/ViewTrackerCard';
import { websiteSettingsRoute } from '../../helpers/routes';
import { TrackingContext } from '../../TrackingContext';
import LinkButton from '../LinkButton';
import styles from './infoHeader.scss';
import Url from './Url';
import GuidanceModule from './GuidanceModule';

import DashboardActionButtons from '../DashboardActionButtons';

import CustomDomainCard from './guidanceCards/CustomDomainCard';
import PublishWebsiteBanner from '../SharedComponents/PublishWebsiteBanner/PublishWebsiteBanner';
import IndexWebsiteBanner from '../SharedComponents/IndexWebsiteBanner/IndexWebsiteBanner';

interface Props {
  hasActiveCustomDomain?: boolean;
  showViewTrackerCard?: boolean;
}

const InfoHeader: React.FC<Props> = ({ hasActiveCustomDomain, showViewTrackerCard }) => {
  const history = useHistory();
  const { track } = useContext(TrackingContext);
  const mobileMedia = useMobileMedia();

  const showDomainCard = !hasActiveCustomDomain;

  const goToWebsiteSettings = () => {
    track('Settings Interaction', {
      selection: 'initiate edit url',
    });
    history.push(websiteSettingsRoute);
  };

  return (
    <FullBleedContainer>
      <div className={styles.container}>
        <PublishWebsiteBanner />
        <IndexWebsiteBanner />
        <TopLevelContainer>
          <Row>
            <Column xs="12">
              <div className={styles.wrapper}>
                <div className={styles.leftWrapper}>
                  <Hero size="md" as="h1">
                    Wedding website
                  </Hero>
                  <div className={styles.copy}>
                    <Body1>
                      <div className={styles.urlWrapper}>
                        <Url track={track} />
                        <LinkButton onClick={goToWebsiteSettings} className={styles.action}>
                          <Body1 className={styles.action}>
                            <Icon data-testid="wws-url-edit-icon" name="edit" />
                          </Body1>
                        </LinkButton>
                      </div>
                    </Body1>
                  </div>
                </div>
                <div className={styles.rightWrapper}>
                  <GuidanceModule>
                    {showViewTrackerCard && <ViewTrackerCard />}
                    {showDomainCard && <CustomDomainCard />}
                  </GuidanceModule>
                  {mobileMedia.yes && <DashboardActionButtons />}
                </div>
              </div>
            </Column>
          </Row>
        </TopLevelContainer>
      </div>
    </FullBleedContainer>
  );
};

export default InfoHeader;
